<template>
    <div class="customer-default-speakers-delete">
        <button type="button" class="button button--icon" @click.prevent="showConfirm = true">
            <IconBin />
        </button>
        <ConfirmModal
            v-if="showConfirm"
            :title="$t('crm.defaultSpeakers.delete.title')"
            :ok-label="$t('misc.delete')"
            @confirmed="deleteItem"
            @canceled="showConfirm = false"
        >
            <template #content>
                <Spinner v-if="loading" />
                <TransitionExpand v-if="error">
                    <ErrorList :error="error" />
                </TransitionExpand>
            </template>
        </ConfirmModal>
    </div>
</template>

<script>
import { deleteCustomersDefaultSpeaker } from '../../api/customers';
import { IconBin } from '@speechki-frontend/shared/ui/icons';
import { ConfirmModal } from '@speechki-frontend/shared/ui/modals';
import { ErrorList } from '@speechki-frontend/shared/ui/forms';
import TransitionExpand from '@speechki-frontend/shared/ui/TransitionExpand';

export default {
    name: 'CustomerDefaultSpeakersDelete',
    components: {
        IconBin,
        ConfirmModal,
        ErrorList,
        TransitionExpand,
    },
    props: {
        itemId: {
            type: [String, Number],
            required: true,
        },
    },
    data() {
        return {
            showConfirm: false,
            loading: false,
            error: undefined,
        };
    },
    methods: {
        async deleteItem() {
            this.loading = true;

            try {
                await deleteCustomersDefaultSpeaker(this.itemId);
                this.$emit('deleted');
            } catch (err) {
                console.log(err);
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>
